const positionValidation = (value, t, fieldName) => {
  if (value === undefined || value === null || value === "") {
    return t("validation.position_is_required");
  }

  const number = parseFloat(value);
  if (isNaN(number)) {
    return t("validation.must_be_a_number");
  }

  const isLatitude = fieldName === "latitude";
  const min = isLatitude ? -90 : -180;
  const max = isLatitude ? 90 : 180;

  if (number < min || number > max) {
    return t("validation.out_of_range", { min, max });
  }

  return undefined;
};

export const validation = (t) => ({
  positionValidation: (value) => positionValidation(value, t),
});
